import React from 'react'

import { Datagrid, DateField, List, ReferenceField, TextField, useRecordContext } from 'react-admin'

import { AccountScoped } from 'shared/react-admin'
import { NotifiableReferenceField } from './NotifiableReferenceField'
import { Notification } from 'shared/types'

const NotificationSummaryField: React.FC<{ record?: Notification; source: string }> = ({ source }) => {
  const record = useRecordContext()
  if (!record) return null

  const value = record[source]

  return <div>{value.split('::').join(' - ')}</div>
}

export const NotificationList = () => (
  <AccountScoped view="Notification List">
    {(accountId: string) => (
      <List empty={false} filter={{ accountId }} exporter={false} perPage={25}>
        <Datagrid rowClick={null}>
          <NotificationSummaryField source="type" />
          <NotifiableReferenceField source="Notify" />
          <ReferenceField source="channel.id" reference="account/channel" label="Channel">
            <TextField source="type" />
          </ReferenceField>

          <DateField source="createdAt" showTime label="Registered" />
        </Datagrid>
      </List>
    )}
  </AccountScoped>
)
